import { render } from "./OurProgram.vue?vue&type=template&id=4b25f399&scoped=true"
import script from "./OurProgram.vue?vue&type=script&lang=js"
export * from "./OurProgram.vue?vue&type=script&lang=js"

import "./OurProgram.vue?vue&type=style&index=0&id=4b25f399&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b25f399"]])

export default __exports__